import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fbf1f9e4&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf1f9e4",
  null
  
)

export default component.exports